const eq = require('./eq')
const hasoption = require('./hasoption')

module.exports = (a, b) => {
  const result = {}
  for (const key in b) {
    const query = b[key]
    if (a[key] != null && !hasoption(query, 'nocache') && eq(a[key], query))
      continue
    result[key] = query
  }
  return result
}
